import { Button } from "@components/button";
import { Input } from "@components/input";
import { Modal } from "@components/modal";
import { useAdminUsers } from "@features/admin/users";
import {
  AddMerchantWalletsRequest,
  AdminUserWallet,
} from "@features/admin/users/api";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

import { useForm, useFieldArray } from "react-hook-form";
import { FlexLoader } from "@components/loader";
import { useEffect, useState } from "react";

type LocalAddWaletsRequest = {
  addresses: { id: string; value: string }[];
};

type Props = {
  isModalOpen: boolean;
  hideModal: () => void;
  wallets: AdminUserWallet[];
  userId: string;
};

const schema = yup.object().shape({
  addresses: yup
    .array()
    .of(
      yup.object().shape({
        id: yup.string().required().trim(),
        value: yup
          .string()
          .required("Address is required")
          .matches(/^T[0-9a-z]{33}$/i, "Invalid address format")
          .trim(),
      })
    )
    .max(3)
    .required(),
});

export const WhitelistWalletsModal = ({
  hideModal,
  isModalOpen,
  wallets,
  userId,
}: Props) => {
  const [oldStates, setOldStates] = useState<string[]>([]);
  const { state, addMerchantWallets, getAdminUserInfo } = useAdminUsers();
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<LocalAddWaletsRequest>({
    defaultValues: {
      addresses: [], // Start with one empty address
    },
    resolver: yupResolver(schema),
  });

  const addresses = watch("addresses");

  const { fields, append, remove } = useFieldArray<LocalAddWaletsRequest>({
    control,
    name: "addresses",
  });

  useEffect(() => {
    reset({
      addresses: wallets.map((wallet, index) => ({
        id: index.toString(),
        value: wallet.address,
      })),
    });
    setOldStates(wallets.map((wallet) => wallet.address));
  }, [wallets]);

  const onSubmit = (data: LocalAddWaletsRequest) => {
    const deleted = oldStates.filter(
      (oldState) =>
        data.addresses.find((address) => address.value == oldState) == null
    );
    const actualData: AddMerchantWalletsRequest = {
      addresses: [],
      deleted_addresses: deleted,
      user_id: userId,
    };
    actualData.addresses = data.addresses
      .filter(
        (address) =>
          oldStates.find((oldState) => oldState == address.value) == null
      )
      .map((address) => address.value);
    addMerchantWallets(actualData).then(() => {
      if (userId) getAdminUserInfo(userId);
      reset();
      // setValue("addresses", [])
      hideModal();
    });
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={hideModal}
      title={"Вайтлист кошельков"}
    >
      {state.isModalLoading ? (
        <FlexLoader />
      ) : (
        <form onSubmit={handleSubmit(onSubmit)}>
          {fields.map((field, index) => (
            <div key={field.id} style={{ marginBottom: "10px" }}>
              <Input
                control={control}
                label={`Адрес ${index + 1}`}
                name={`addresses.${index}.value`}
              />
              {errors.addresses?.[index]?.value?.message && (
                <p>{errors.addresses?.[index]?.value?.message}</p>
              )}
              {fields.length > 1 && (
                <span
                  onClick={() => {
                    remove(index);
                  }}
                  style={{
                    marginLeft: "10px",
                    cursor: "pointer",
                    color: "red",
                  }}
                >
                  Удалить
                </span>
              )}
            </div>
          ))}
          {addresses.length < 3 && (
            <Button
              buttonType="button"
              onClick={() =>
                append({ id: new Date().toISOString(), value: "" })
              }
              style={{ marginTop: "10px" }}
            >
              Добавить адрес
            </Button>
          )}
          {<Button style={{ marginTop: "10px" }}>Сохранить Адреса</Button>}
        </form>
      )}
    </Modal>
  );
};
